<template>
  <div class="row transaction">
    <div class="spinner-grow" role="status" v-if="loading === true"></div>
    <div class="col-auto">
      <div class="row">
        <div class="form-row align-items-end">
          <div class="col-auto">
            <label for="inlineFormInput">Status</label>
            <select class="form-control" v-model="status">
              <option value="">Select Status</option>
              <option value="pending">Pending</option>
              <option value="failed">Completed</option>
            </select>
          </div>
          <div class="col-auto">
            <label>Reference</label>
            <div class="input-group m-0">
              <input
                type="text"
                class="form-control"
                id="inlineFormInputGroup"
                placeholder="Reference"
                v-model="reference"
              />
            </div>
          </div>

          <div class="col-auto">
            <label>Start Date</label>
            <div class="input-group m-0">
              <input
                type="date"
                class="form-control"
                id="inlineFormInputGroup"
                placeholder="Start Date"
                v-model="startDate"
              />
            </div>
          </div>

          <div class="col-auto">
            <label>End Date</label>
            <div class="input-group m-0">
              <input
                type="date"
                class="form-control"
                id="inlineFormInputGroup"
                placeholder="End Date"
                v-model="endDate"
              />
            </div>
          </div>

          <div class="col-auto">
            <button
              type="submit"
              class="btn btn-primary"
              @click="refresh('filter')"
            >
              Filter
            </button>
          </div>

          <button
            type="submit"
            class="btn btn-primary"
            @click="refresh('refresh')"
          >
            Refresh
          </button>

          <router-link
            class="btn btn-primary ml-2"
            :to="`/dashboard/initiate-funding`"
          >
            Initiate Funding
          </router-link>
        </div>
      </div>
    </div>
    <div class="col-12 p-0">
      <card class="card-plain p-0">
        <div class="table-full-width table-responsive">
          <table class="table">
            <thead class="thead-dark">
              <tr>
                <th scope="col" class="text-center">S/N</th>
                <th scope="col" class="text-center">WalletID</th>
                <th scope="col" class="text-center">User</th>
                <th scope="col" class="text-center">Type</th>
                <th scope="col" class="text-center">Amount</th>
                <th scope="col" class="text-center">Initialed By</th>
                <th scope="col" class="text-center">ApprovedBy|RejectedBy</th>
                <th scope="col" class="text-center">Status</th>
                <th scope="col" class="text-center">Reference</th>
                <th scope="col" class="text-center">Description</th>
                <th scope="col" class="text-center">Date</th>
                <th scope="col" class="text-center">Action</th>
              </tr>
            </thead>
            <tbody>
              <tr v-if="requests.length === 0">
                <td colspan="10" class="text-center">No data found</td>
              </tr>
              <tr v-for="(request, index) in requests" :key="request._id">
                <th class="text-center">{{ index + 1 }}</th>
                <td class="text-center">{{ request.walletId }}</td>
                <td class="text-center">{{ request.user }}</td>
                <td class="text-center">{{ request.type }}</td>
                <td class="text-center">
                  {{ `₦${format.format(request.amount.toFixed(4))}` }}
                </td>
                <td class="text-center">
                  {{ request.firstName + " " + request.lastName }}
                </td>
                <td class="text-center">{{ request.approvedBy }}</td>
                <td class="text-center">
                  <span
                    style="font-size: small"
                    :class="`p-2  text-white bg-${getColor(request.status)}`"
                    >{{ request.status }}</span
                  >
                </td>
                <td class="text-center">{{ request.reference }}</td>
                <td class="text-center">{{ request.description }}</td>
                <td class="text-center">
                  {{ moment(request.createdAt).format("Y-M-D h:mm:ss a") }}
                </td>
                <td class="text-center">
                  <router-link :to="`/dashboard/fund-request/${request._id}`">
                    View Details
                  </router-link>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </card>
    </div>

    <div class="pagination" style="justify-content: space-between; width: 100%">
      <div
        class="to-flex"
        style="display: flex; align-items: center; gap: 10px"
      >
        <button
          class="btn"
          :disabled="hasPrevPage === false"
          @click="refresh('previous')"
        >
          Previous
        </button>

        <span>Page {{ currentPage }} of {{ totalPages }}</span>

        <button class="btn" :disabled="!hasNextPage" @click="refresh('next')">
          Next
        </button>
      </div>

      <div class="p-2">
        <div class="btn">Total Records: {{ totalDocs }}</div>
      </div>
    </div>
  </div>

  <!-- </div> -->
</template>
<script>
import axios from "../store/axios";
import moment from "moment";
import { mapState, mapActions } from "vuex";
export default {
  components: {},
  data() {
    return {
      error: false,
      requests: [],
      errorMsg: "",
      moment,
      loading: false,
      format: new Intl.NumberFormat("en-US", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      }),
      page: 1,
      currentPage: 1,
      totalDocs: 0,
      limit: 50,
      totalPages: 0,
      hasPrevPage: false,
      hasNextPage: true,
      prevPage: null,
      nextPage: null,
      type: "",
      walletId: "",
      reference: "",
      startDate: moment().format("YYYY-MM-DD"),
      endDate: moment().format("YYYY-MM-DD"),
    };
  },
  computed: {
    ...mapState(["loading", "auth"]),
  },
  methods: {
    ...mapActions(["getMerchant", "setNotification"]),
    async refresh(mode) {
      try {
        this.loading = true;
        let payload = {
          page: this.page,
          limit: this.limit,
          startDate: this.startDate,
          endDate: this.endDate,
          walletId: this.walletId,
          status: this.status,
          reference: this.reference,
        };

        if (mode === "refresh") {
          this.page = 1;
          this.currentPage = 1;
          this.startDate = moment().format("YYYY-MM-DD");
          this.endDate = moment().format("YYYY-MM-DD");
        }

        switch (mode) {
          case "next":
            payload = { ...payload, page: this.nextPage };
            this.currentPage = this.nextPage;
            break;
          case "previous":
            payload = { ...payload, page: this.prevPage };
            this.currentPage = this.prevPage;
            break;
        }
        const res = await axios
          .get(`${process.env.VUE_APP_API_URL}/initiate/get-requests`, {
            params: payload,
          })
          .then((res) => res.data.requests)
          .then((data) => {
            this.requests = data;
          });
        const {
          docs,
          hasNextPage,
          hasPrevPage,
          totalPages,
          totalDocs,
          prevPage,
          nextPage,
          page,
        } = this.requests;
        this.requests = docs;
        this.hasPrevPage = hasPrevPage;
        this.hasNextPage = hasNextPage;
        this.totalPages = totalPages;
        this.prevPage = prevPage;
        this.nextPage = nextPage;
        this.totalDocs = totalDocs;
        this.page = page;
      } catch (err) {
        console.log(err);
        this.setNotification({
          type: "danger",
          message: "Unable to Fetch Requests",
        });
      }
      this.loading = false;
    },

    getColor(status) {
      let color = null;
      switch (status) {
        case "pending":
          color = "info";
          break;
        case "rejected":
          color = "danger";
          break;
        case "approved":
          color = "success";
          break;
        case "cancelled":
          color = "warning";
          break;
      }
      return color;
    },
  },

  async mounted() {
    try {
      this.loading = true;

      const res = await axios
        .get(`${process.env.VUE_APP_API_URL}/initiate/get-requests`, {
          params: {
            page: this.page,
            limit: this.limit,
            startDate: moment().format("YYYY-MM-DD"),
            endDate: moment().format("YYYY-MM-DD"),
          },
        })
        .then((res) => res.data.requests)
        .then((data) => {
          this.requests = data;
        });
      const {
        docs,
        hasNextPage,
        hasPrevPage,
        totalPages,
        totalDocs,
        prevPage,
        nextPage,
      } = this.requests;
      this.requests = docs;
      this.hasPrevPage = hasPrevPage;
      this.hasNextPage = hasNextPage;
      this.totalPages = totalPages;
      this.prevPage = prevPage;
      this.nextPage = nextPage;
      this.totalDocs = totalDocs;
    } catch (err) {
      console.log(err);
      this.setNotification({
        type: "danger",
        message: "Unable to Fetch Requests",
      });
    }

    this.loading = false;
  },
};
</script>
<style scoped>
.transaction {
  font-size: 12px;
}

th {
  font-size: 12px !important;
}

.spinner-grow {
  position: fixed;
}

.card .card-body {
  padding: 0 !important;
}
</style>
